import _529CreditsData from "../data/529CreditsData";
import _529Credits from "./529Credits";

export default {
  _529Credits: _529Credits(_529CreditsData)
}